<template>
  <div
    v-if="loading"
    class="follow-ups"
    role="status"
    aria-label="Loading suggested follow-ups"
  >
    <span v-for="n in 3" :key="n" class="follow-up-skeleton" />
  </div>
  <div v-else class="follow-ups" role="group" aria-label="Suggested follow-ups">
    <button
      v-for="chip in chips"
      :key="chip"
      type="button"
      class="follow-up-chip"
      @click="$emit('pick', chip)"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
        stroke="var(--oliver-accent)"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M4 2.5v5a3 3 0 0 0 3 3h6.5M10.5 7.5l3 3-3 3" />
      </svg>
      <span>{{ chip }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "FollowUpChips",
  props: {
    chips: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  emits: ["pick"],
};
</script>

<style scoped lang="scss">
.follow-ups {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 6px 0 4px;
  animation: follow-ups-in 0.3s ease both;
}

.follow-up-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid var(--oliver-accent-border);
  background: var(--oliver-assistant-bg);
  color: var(--oliver-text);
  font: inherit;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;

  &:hover {
    background: var(--oliver-accent-light);
    border-color: var(--oliver-accent);
    color: var(--oliver-accent);
  }

  &:focus-visible {
    outline: 2px solid var(--oliver-accent);
    outline-offset: 2px;
  }

  svg {
    flex-shrink: 0;
  }
}

.follow-up-skeleton {
  height: 44px;
  max-width: 100%;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    rgba(127, 127, 127, 0.08) 0%,
    var(--oliver-accent-border) 50%,
    rgba(127, 127, 127, 0.08) 100%
  );
  background-size: 200% 100%;
  opacity: 0.4;
  animation: follow-ups-shimmer 2.4s linear infinite;

  &:nth-child(1) {
    width: 230px;
  }
  &:nth-child(2) {
    width: 250px;
  }
  &:nth-child(3) {
    width: 200px;
  }
}

@keyframes follow-ups-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

@keyframes follow-ups-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .follow-ups {
    animation: none;
  }
  .follow-up-chip {
    transition: none;
  }
  .follow-up-skeleton {
    animation: none;
  }
}
</style>
